import Store from '../flux/Store';
import zoomerActions from '../actions/zoomer';
import config from '../config';

// static configurations
var minScale = 1;
var maxScale = 50;
var scaleStep = (maxScale - minScale) / 100;

/**
 * TODO, MOVE DOM CALCULATIONS TO THE VIEW
 * @class ZoomerStore
 */
class ZoomerStore extends Store {

  init () {
    zoomerActions.on(zoomerActions.EVENTS.REGISTER, this.register.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.DE_REGISTER, this.deRegister.bind(this));

    zoomerActions.on(zoomerActions.EVENTS.ZOOM, this.zoom.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.PINCH, this.pinch.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.MOVE, this.move.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.RESET, this.resetZoom.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.FIT_IN_VIEW, this.fitInView.bind(this));

    zoomerActions.on(zoomerActions.EVENTS.CLICK_DISABLE, this.disableClick.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.CLICK_RESET, this.resetClick.bind(this));

    zoomerActions.on(zoomerActions.EVENTS.SCROLL_TO_ZOOM, this.scrollToZoom.bind(this));
  }

  // TODO, should check if better somewhere else
  scrollToZoom (enable) {
    config.system.scrollToZoom = !!enable;
    this.done();
  }

  // When the zoomer mounts it will register itself, on unmount it will de-register
  //---------------------------------------------------------------------------
  register (node) {
    this.data.container = node;
    this.done();
  }

  deRegister () {
    this.data.container = null;
    this.done();
  }

  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

  // When panning the map, we don't want to perform the click
  //---------------------------------------------------------------------------
  disableClick () {
    this.data.clickDisabled = true;
    this.done();
  }

  resetClick () {
    this.data.clickDisabled = false;
    this.done();
  }

  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

  fitInView (childNode) {
    if (!this.data.container || !childNode) return;

    var containerSize = this.getContainerSize();
    var containerCenter = this.getContainerCenter();

    var polygonRect = childNode.getBoundingClientRect();

    var oldScale = this.data.scale;

    var newCenter = {
      x: (polygonRect.left - containerSize.left + (polygonRect.width / 2)) - this.data.translateX,
      y: (polygonRect.top - containerSize.top + (polygonRect.height / 2)) - this.data.translateY
    };

    // calculate new scale
    var windowPadding = 10;
    var scaleDiffH = (containerSize.height - windowPadding) / polygonRect.height;
    var scaleDiffW = (containerSize.width - windowPadding) / polygonRect.width;

    this.data.scale *= Math.min(scaleDiffH, scaleDiffW);
    // normalize the scale
    this.data.scale = Math.max(Math.min(this.data.scale, maxScale), minScale);
    // find the ratio of the new scale
    var ratio = this.data.scale / oldScale;

    this.data.translateX = containerCenter.x - (newCenter.x * ratio);
    this.data.translateY = containerCenter.y - (newCenter.y * ratio);

    this.checkTranslateRanges();
  }

  move (diffX, diffY) {
    if (!this.data.container) return;
    // execute the calculations only if the view is mounted
    this.data.translateX += +diffX;
    this.data.translateY += +diffY;
    this.checkTranslateRanges();
  }

  zoom (direction, zoomCenter) {
    // required parameter
    if (!this.data.container) return;

    var oldScale = this.data.scale;
    zoomCenter = zoomCenter || this.getContainerCenter();

    // start by setting the scale
    this.data.scale += (+direction * scaleStep);
    // normalize the scale
    this.data.scale = Math.max(Math.min(this.data.scale, maxScale), minScale);
    // find the ratio of the new scale
    var ratio = this.data.scale / oldScale;

    var realX = zoomCenter.x - this.data.translateX;
    var realY = zoomCenter.y - this.data.translateY;

    this.data.translateX = -1 * (ratio * realX - zoomCenter.x);
    this.data.translateY = -1 * (ratio * realY - zoomCenter.y);

    this.checkTranslateRanges();
  }

  resetZoom () {
    this.data.scale = 1;
    this.data.translateX = 0;
    this.data.translateY = 0;
    this.data.clickDisabled = false;
    this.data.center = {
      x: 0,
      y: 0
    };
    this.done();
  }

  pinch (opts) {
    if (!this.data.container || !opts || !opts.lastDist || !opts.newDist || !opts.lastCenter || !opts.newCenter) {
      return new Error('Error calling the zoomPinch function');
    }
    var lastCenter = opts.lastCenter;
    var newCenter = opts.newCenter;

    var diffX = newCenter.x - lastCenter.x;
    var diffY = newCenter.y - lastCenter.y;

    var oldScale = this.data.scale;
    var incrementRatio = opts.newDist / opts.lastDist;

    // start by setting the scale
    this.data.scale = this.data.scale * incrementRatio;
    // normalize the scale
    this.data.scale = Math.max(Math.min(this.data.scale, maxScale), minScale);
    // find the ratio of the new scale
    var ratio = this.data.scale / oldScale;

    var realX = newCenter.x - this.data.translateX;
    var realY = newCenter.y - this.data.translateY;

    this.data.translateX = -1 * (ratio * realX - newCenter.x - diffX);
    this.data.translateY = -1 * (ratio * realY - newCenter.y - diffY);

    this.checkTranslateRanges();
  }

  // UTILS
  // ----------------------------------------------------------------
  /**
   * This is the function that keeps the map always in view. It should be called always after every zoom/pan
   */
  checkTranslateRanges () {
    // execute the calculations only if the view is mounted
    var minimumTranslations = this.getMinTranslations();
    this.data.translateX = Math.round(Math.max(Math.min(this.data.translateX, 0), minimumTranslations.x) * 100) / 100;
    this.data.translateY = Math.round(Math.max(Math.min(this.data.translateY, 0), minimumTranslations.y) * 100) / 100;
    this.done();
  }

  /**
   * @returns {{x: number, y: number}}
   */
  getMinTranslations () {
    var min = {x: 0, y: 0};
    var containerSize = this.getContainerSize();

    if (containerSize) {
      try {
        min.x = -1 * containerSize.width * (this.data.scale - 1);
        min.y = -1 * containerSize.height * (this.data.scale - 1);
      }
      catch (e) { /* do nothing */
      }
    }
    return min;
  }

  /**
   * @returns {{x: number, y: number}}
   */
  getContainerCenter () {
    var center = {x: 0, y: 0};
    var containerSize = this.getContainerSize();

    if (containerSize) {
      try {
        center.x = containerSize.width / 2;
        center.y = containerSize.height / 2;
      }
      catch (e) { /* do nothing */
      }
    }
    return center;
  }

  getContainerSize () {
    return this.data.container ? this.data.container.getBoundingClientRect() : null;
  }
}

/** @type {ZoomerStore} */
export default new ZoomerStore({
  container:     null,
  containerSize: null,
  scale:         minScale,
  translateX:    0, // TODO, check if we can define %
  translateY:    0, // TODO, check if we can define %
  clickDisabled: false,
  center:        {
    x: 0,
    y: 0
  }
});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/stores/zoomer.js